import Vue from 'vue'
import Vuex from 'vuex'
import Common from './api/common'

Vue.use(Vuex)
/**
 * 导出一个 Vuex Store 实例，用于管理应用的全局状态。
 * Vuex 是一个专为 Vue.js 应用程序开发的状态管理模式 + 库，它采用集中式存储管理应用的所有组件的状态。
 * 通过创建并导出这个 Store 实例，其他 Vue 组件可以通过 this.$store 来访问和修改全局状态。
 */
export default new Vuex.Store({
	state: {
		User: {
			name: '星空',
			desc: '执着于理想，纯粹于当下',
			email: 'HeyUI@some.com',
			org: '某某公司',
			dept: '某某部门',
			title: '前端开发工程师',
			location: '上海市',
			avatar: '/images/avatar.png',
			tags: ['善解人意', '耿直']
		},
				// 当前选中的账套信息，初始化为空对象。
		// 后续在业务流程中，该对象会存储当前正在使用的账套的相关数据。
		currentAccountSets: {},
		// 存储用户所有账套信息的数组，初始化为空数组。
		// 该数组会在获取用户账套列表后，将各个账套信息添加到数组中。
		myAccountSets: [],
		// 控制侧边栏是否折叠的状态标识，初始值为 false 表示侧边栏默认展开。
		// 当值为 true 时，侧边栏会折叠；值为 false 时，侧边栏会展开。
		sliderCollapsed: false

	},
		/**
	 * mutations 对象用于定义修改 Vuex store 中状态的方法。
	 * 在 Vuex 里，只有 mutations 方法可以直接修改状态，且这些方法必须是同步的。
	 */
	mutations: {
		/**
		 * 更新用户账户信息以及账套信息
		 * @param {Object} state - 当前 Vuex store 的状态对象
		 * @param {Object} data - 包含新的用户信息和账套信息的数据对象
		 */
		updateAccount(state, data) {
			// 将用户信息更新为传入的数据
			state.User = data;
			// 将当前选中的账套信息更新为传入数据中的 accountSets 属性值
			state.currentAccountSets = data.accountSets;
			// 将用户所有账套信息数组更新为传入数据中的 accountSetsList 属性值
			state.myAccountSets = data.accountSetsList;
		},
		/**
		 * 更新侧边栏折叠状态，并触发页面尺寸调整事件
		 * @param {Object} state - 当前 Vuex store 的状态对象
		 * @param {boolean} isShow - 侧边栏是否展开的标识，true 表示展开，false 表示折叠
		 */
		updateSliderCollapse(state, isShow) {
			// 延迟 600 毫秒后触发页面尺寸调整事件，可能用于更新页面布局
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			// 更新侧边栏折叠状态
			state.sliderCollapsed = isShow;
		}
	},

		/**
	 * actions 对象用于定义异步操作或包含多个 mutation 的复杂操作。
	 * 在 Vuex 中，actions 不直接修改状态，而是通过提交 mutations 来间接修改状态。
	 */
	actions: {
		/**
		 * 初始化应用数据
		 * 该 action 会调用 API 接口获取初始化数据，并提交 mutation 更新状态。
		 * @param {Object} context - 包含与 store 实例相同方法和属性的 context 对象，可用于提交 mutations 等操作。
		 * @returns {Promise} 一个 Promise 对象，成功时返回获取到的数据，失败时拒绝该 Promise。
		 */
		init(context) {
			return new Promise((resolve, reject) => {
				// 调用 Common 模块的 init 方法获取初始化数据
				Common.init().then(({data}) => {
					// 提交 updateAccount mutation，将获取到的数据更新到 state 中
					context.commit('updateAccount', data);
					// 当数据获取和状态更新成功时，将获取到的数据作为结果返回
					resolve(data)
				}).catch(() => {
					// 当数据获取失败时，拒绝该 Promise
					reject();
				})
			});
		}
	},

		/**
	 * getters 对象用于定义从 Vuex store 中获取派生状态的方法。
	 * 类似于 Vue 组件中的计算属性，getters 的返回值会根据其依赖的状态缓存，
	 * 只有当依赖的状态发生变化时才会重新计算。
	 */
	getters: {
		/**
		 * 获取当前用户的账户信息。
		 * @param {Object} state - 当前 Vuex store 的状态对象。
		 * @returns {Object} 当前用户的账户信息对象。
		 */
		account: state => {
			// 从 state 中获取 User 对象并返回
			return state.User;
		},
		/**
		 * 获取侧边栏的折叠状态。
		 * @param {Object} state - 当前 Vuex store 的状态对象。
		 * @returns {boolean} 侧边栏的折叠状态，true 表示折叠，false 表示展开。
		 */
		sliderCollapsed: state => {
			// 从 state 中获取 sliderCollapsed 属性并返回
			return state.sliderCollapsed;
		}
	}

})
